// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  // redirecionamentos
  { path: '/',          redirect: '/partidas' },
  { path: '/games',     redirect: '/partidas' },
  { path: '/profilebeta/:username',
    redirect: to => ({ name: 'ProfilePage', params: { username: to.params.username } })
  },
  { path: '/profile/:username',
    redirect: to => ({ name: 'ProfilePage', params: { username: to.params.username } })
  },

  // rotas principais
  {
    path: '/partidas',
    name: 'GamesPageBeta',
    component: () => import('@/views/MainPage.vue')
  },
  {
    path: '/feed',
    name: 'Feed',
    component: () => import('@/views/FeedPage.vue')
  },
  {
    path: '/perfil/:username',
    name: 'ProfileBeta',
    component: () => import('@/views/ProfilePage.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/verify/:token',
    name: 'Verify',
    component: () => import('@/views/VerifyEmail.vue')
  },
  {
    path: '/partida/:id',
    name: 'GameTest',
    component: () => import('@/views/GamePage.vue')
  },
  {
    path: '/avaliacao/:id',
    name: 'RecordPage',
    component: () => import('@/views/RecordPage.vue')
  },
  {
    path: '/time/:name/:id',
    name: 'TeamPage',
    component: () => import('@/views/TeamPage.vue')
  },
  {
    path: '/liga/:name/:id',
    name: 'LeaguePage',
    component: () => import('@/views/LeaguePage.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Retorna ao topo sempre que trocar de rota
    return { top: 0 };
  }
})

router.beforeEach((to, from, next) => {
  // Define as rotas públicas utilizando os prefixos dos paths
  const publicPages = ['/login', '/games', '/verify', '/partida', '/perfil', '/time', 
                        '/liga', '/avaliacao', '/feed'];
  const isPublic = publicPages.some(prefix => to.path.startsWith(prefix));
  const token = localStorage.getItem('jwtToken');

  // Se a rota não for pública e não houver token válido, redireciona para login
  if (!isPublic && (!token || token.trim() === '')) {
    return next('/login');
  }
  next();
});



export default router